module.exports = __webpack_public_path__ + "img/icon-close-black.1ecb86df.svg";